<div class="row">
  <div class="col-12">
    <div class="card w-100">
      <div class="card-body d-flex flex-column">
        <h5>
          {{ 'pages.transport.tracking-overview.widgets.watched-shipments.title' | translate }}
        </h5>
        @if (isLoading()) {
          <p-skeleton class="mb-2" />
          <p-skeleton width="10rem" class="mb-2" />
          <p-skeleton width="5rem" class="mb-2" />
          <p-skeleton height="2rem" class="mb-2" />
          <p-skeleton width="10rem" height="4rem" />
        }

        @if (isSuccess()) {
          <div class="watched-shipments">
            <p-dataview
              [value]="reversedData()"
              [paginator]="true"
              [showPageLinks]="true"
              [pageLinks]="3"
              [showFirstLastIcon]="false"
              [rows]="5"
              styleClass="border-0"
              [alwaysShowPaginator]="false"
              paginatorStyleClass="p--0"
            >
              <ng-template #list let-tabs>
                <table class="watched-shipments__table">
                  <thead>
                    <tr class="sr-only d-none">
                      <th class="watched-shipments__table__header">
                        {{ 'pages.transport.tracking-overview.widgets.watched-shipments.data-fields.name' | translate }}
                      </th>
                      <th class="watched-shipments__table__header"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (tab of tabs; track tab.id) {
                      <tr>
                        <td class="watched-shipments__table__cell">{{ tab.displayName }}</td>
                        <td class="watched-shipments__table__cell">
                          <p-button
                            icon="pi pi-external-link"
                            (onClick)="goToWatchedShipment(tab)"
                            [rounded]="true"
                            styleClass="watched-shipments__table__cell__openlink"
                            variant="text"
                          />
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </ng-template>
            </p-dataview>
          </div>
        }

        @if (isEmpty()) {
          <h6 class="empty-state__title mt--16 mb--24">
            {{ 'pages.transport.tracking-overview.widgets.watched-shipments.empty-state.title' | translate }}
          </h6>
          <p class="empty-state__instructions">
            {{ 'pages.transport.tracking-overview.widgets.watched-shipments.empty-state.instructions' | translate }}
          </p>
          <div class="d-flex justify-content-end">
            <p-button
              icon="pi pi-external-link"
              iconPos="right"
              [label]="'pages.transport.tracking-overview.widgets.watched-shipments.empty-state.open-tracking-list' | translate"
              (onClick)="goToDetailsPage()"
              styleClass="ml--4"
              variant="text"
            />
          </div>
        }

        @if (isOnError()) {
          <p-message severity="error">
            <span class="bold">
              {{ errorMessage().title }}
            </span>
            <span>
              {{ errorMessage().description }}
            </span>
          </p-message>
        }
      </div>
    </div>
  </div>
</div>
